import { useMemo } from 'react';

import { getSmsDetails } from 'common-src/utils/smsUtils';

const useSmsCalculator = (text = '') =>
  useMemo(() => {
    const safeText = text || '';
    const details = getSmsDetails(safeText);
    const isOverLimit = details.isOverLimit === true;
    const length = isOverLimit ? safeText.length : details.length;

    return {
      encoding: isOverLimit ? 'Unicode' : details.encoding,
      length,
      // For UX consistency, show 1 segment for empty/new draft state.
      segments: isOverLimit ? Math.ceil(length / 67) : details.length === 0 ? 1 : details.segments,
      isOverLimit,
      error: isOverLimit ? details.error : '',
    };
  }, [text]);

export default useSmsCalculator;
